import { InjectionToken, Type } from '@angular/core';
import { ConsensusReconciliationReconnectHandler } from 'demand-forecasting/store/consensus/consensus-reconciliation-reconnect.handler';
import { ForecastProgressReconnectHandler } from 'demand-forecasting/store/forecast-version/forecast-progress-reconnect.handler';

export interface SseReconnectHandler {
  onReconnect(): void;
}

export const SSE_RECONNECT_HANDLER = new InjectionToken<SseReconnectHandler[]>(
  'SSE_RECONNECT_HANDLER',
);

export const SSE_RECONNECT_HANDLERS: Type<SseReconnectHandler>[] = [
  ForecastProgressReconnectHandler,
  ConsensusReconciliationReconnectHandler,
];
